import React from 'react';
import { TinyColor } from '@ctrl/tinycolor';
import { useTheme } from '@emotion/react';
import { type ExperienceFullWidthHeaderCard } from '@bbkAdminRedux/rtkq/experience.slice';
import { type RestExperience } from '@bbkAdminUtils/api-client/rest-experiences-api';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { ThemeKeys, type EmotionTheme } from '@bbkFunnel/pages/theme';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './top.scss';

type Props = {
  card: ExperienceFullWidthHeaderCard;
  fullInfo: Pick<RestExperience, 'company'>;
};
export const FullWidthHeader: ReactFCC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const {
    card,
    card: {
      requires: { company: companyCard },
      style_overlay: customStyles,
    },
    fullInfo: { company: companyFullInfo },
  } = props;

  const company = companyFullInfo.brandingLogoActivated
    ? companyFullInfo
    : companyCard;
  const topLevelHeaderBackground = new TinyColor(
    theme[ThemeKeys.PRIMARY_COLOR]
  );
  const customStylesBuilt = {
    background: topLevelHeaderBackground.darken(30).toHexString(),
    ...customStyles,
  };

  return (
    <div
      className={cs(
        'bbk-full-width-header-survey fullWidthHeaderSurvey',
        makeClassNameSafe(card.name)
      )}
      css={[customStylesBuilt]}
    >
      <img
        src={company.logo}
        alt={company.name || 'logo'}
        css={customStyles.logo}
      />
    </div>
  );
};
